import styled from "@emotion/styled";
import { Flex } from "@otrium/core";

const Wrapper = styled(Flex)`
  flex-wrap: wrap;
  justify-content: end;
  & > * {
    margin: 2px;
    flex-basis: 32px;
  }
`;

export { Wrapper };
